export default "__VITE_ASSET__7371b380__"